// Pure helpers for the Edit Field form's save path.
// Kept dependency-free (no React / webpack aliases) so they can be unit-tested
// in isolation with `node --test`.

// True while the sensors section has an unsaved add/edit row open (the user has
// typed into it but not pressed Done yet).
//
// `SensorsWrapper` keeps the typed values in `EditSensor`'s own local state and
// only lifts them up on Done, so saving while a row is open would silently drop
// them. The wrapper reports this flag up so the form can block Update instead.
const isSensorSectionOpen = ({ addNewFieldClicked, sensorEditIndex } = {}) =>
  Boolean(addNewFieldClicked) || (sensorEditIndex ?? '') !== '';

// True when the Update/Create button must be blocked because some sub-section
// still holds unsaved input. Every section that buffers input locally has to be
// represented here, otherwise its edits are lost without any warning.
const shouldBlockSubmitForOpenEdits = (openEditSections = {}) =>
  Boolean(openEditSections.sensors) || Boolean(openEditSections.timeFrames);

// Build the field object to send to the API.
//
// The name MUST come from `currentField` (React state, which is loaded from the
// field the user actually opened) and never from a detached DOM input: the
// uncontrolled `<input>` used to be synced only inside a jQuery
// `show.bs.modal` handler, so when that handler didn't run for an open, the
// input still held the PREVIOUSLY edited field's name and we happily PUT it
// onto the field currently being saved.
const buildFieldForSave = ({ currentField, clusterId, soilType }) => {
  const field = { ...currentField };

  field.name = currentField?.name ?? '';
  field.cluster = { ...(currentField?.cluster || {}), id: clusterId };
  field.soil_type = soilType;

  return field;
};

module.exports = {
  isSensorSectionOpen,
  shouldBlockSubmitForOpenEdits,
  buildFieldForSave,
};
